const thirdParty = {
  thirdParty: {
    pageHeader: 'Generación de reportes de terceros',
    clearState: 'Borrar estado',
    register: 'Registrar',
    systemRegistrationSummary: 'Resumen de registro del sistema',
    registrationProgress: '%{registration_in_progress} en curso',
    registrationComplete: '%{registration_complete} completo',
    thirdPartyLogin: 'Inicie sesión como propietario del sitio para administrar su cuenta de PowerDash',
    thirdPartyInvalidURI: 'El URI solicitado o el recurso solicitado no es válido, no existe como un sistema.'
  }
};

export default thirdParty;
